import './App.css';
import './pages/main'
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import MainPage from './pages/main';
import AboutMe from './pages/aboutme'
function App() {
  return (
    <BrowserRouter>
    <Routes>
     
      
      <Route path="/" element={<MainPage/>} />
      <Route path="/aboutme" element={<AboutMe/>} />
   
    </Routes>
  </BrowserRouter>
  )
}

export default App;
